import VideoPopup from './video-popup';
import Scroll from '../util/Scroll';

const DEFAULTS = {
}

export default class PostTypeFilter {

  constructor (el, options) {
    this.options = options;
    this.$el = $(el)
    this.type = this.$el.data('post-type')
    this.$result = this.$el.find('[data-result-container]')
    this.$paginationPages = this.$el.find('[data-pagination-pages]')
    this.currentPage = 1
    this.maxPage = 1
    this.$prev = this.$el.find('[data-page-prev]')
    this.$next = this.$el.find('[data-page-next]')
    this.maxPage = 1
    this.init();
  }

  /**
   * Register this component as global jquery plugin
   */
  static jqueryPlugin () {
    $.fn.postTypeFilter = function (option) {
        var args = Array.prototype.slice.call(arguments, 1)
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('trueper.post-type-filter')
            var options = $.extend({}, DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('trueper.post-type-filter', (data = new PostTypeFilter(this, options)))
            else if (typeof option == 'string') data[option].apply(data, args)
        })
    }
    $.fn.postTypeFilter.Constructor = PostTypeFilter
    $('[data-control="post-filter"]').postTypeFilter();
  }

  init () {
    this.$filterSalon = $('.js-filter-salon')
    this.$filterRange = $('.js-filter-range')
    this.$filterSalon.on('change.select2', () => {
      this.updateURLParameter()
      this.fetch()
    });
    this.$filterRange.on('change.select2', () => {
      this.updateURLParameter()
      this.fetch()
    });
    this.$prev.on('click', () => {
      if (this.currentPage <= 1) {
        return
      }
      this.currentPage--
      this.fetch()
    })
    this.$next.on('click', () => {
      if (this.currentPage >= this.maxPage) {
        return
      }
      this.currentPage++
      this.fetch()
    })
    this.$el.on('click', '.js-filter-page', (e) => {
      let page = $(e.currentTarget).data('page')
      if (parseInt(page) === this.currentPage) {
        return
      }
      this.currentPage = page
      this.fetch()
    })
    this.fetch()
  }

  fetch () {
    let params = this.getParams()
    this.$result.empty()
    this.$result.html(this.spinnerHtml)
    $.get(window.ajaxurl, params, (result) => {
      setTimeout(() => {
        this.updateResult(result)
      }, 1000);
    });
  }

  getParams () {
    return {
      salon: this.$filterSalon.val(),
      range: this.$filterRange.val(),
      action: 'fetch_service_post',
      paged: this.currentPage,
      service_type: this.type,
    }
  }

  updateResult (data) {
    this.maxPage = data.count
    this.$result.html(data.html)
    this.$paginationPages.html(data.pagination_html)
    const disableCss = 'disabled cursor-not-allowed opacity-50'
    if (this.currentPage >= this.maxPage) {
      this.$next.addClass(disableCss)
    } else {
      this.$next.removeClass(disableCss)
    }
    if (this.currentPage <= 1) {
      this.$prev.addClass(disableCss)
    } else {
      this.$prev.removeClass(disableCss)
    }
    this.bindEvents()
    setTimeout(() => {
      let scroll = new Scroll
      scroll.scrollTo(this.$result.offset().top - 200)
    }, 100);
  }

  bindEvents () {
    let player = new VideoPopup('.js-video-popup')
    player.init()
  }

  spinnerHtml () {
    return `
    <div class="pt-6 pb-6"
      style="min-height: 480px;">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    `
  }
  /**
   * http://stackoverflow.com/a/10997390/11236
   */
  updateURLWithParameter (url, param, paramVal) {
    var newAdditionalURL = '';
    var tempArray = url.split('?');
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (var i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }

    var rows_txt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rows_txt;
  }

  /**
   * Update URL state to reflect current filters
   */
  updateURLParameter () {
    let params = {}
    if (this.$filterSalon.val()) {
      let value = this.$filterSalon.val()
      let slug = this.$filterSalon.find(`option[value="${value}"]`).data('option-slug')
      params['category'] = slug
    }
    let url = window.location.href
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        url = this.updateURLWithParameter(url, key, value)
      }
    }
    window.history.replaceState({path:url},'',url);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/post-type-filter.js